import React from 'react';
import { HomeMemberCenterLayout, HomeMemberChangePassword } from 'components';


/**
 * 在這邊描述這個組件
 */

export const HomeMemberChangePasswordPage = () => {
  return (
    <HomeMemberCenterLayout>
      <HomeMemberChangePassword />
    </HomeMemberCenterLayout>
  );
};
